import type { ListTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import * as styles from './ListActionsPopoverSkeleton.module.less';

export const ListActionsPopoverSkeleton = () => (
  <div
    data-testid={getTestId<ListTestIds>('list-actions-popover-skeleton')}
    className={styles.skeletonWrapper}
  >
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonSectionTitle} />
    <div className={styles.skeletonColorSection} />
    <div className={styles.skeletonSectionTitle} />
    <div className={styles.skeletonButlerOption} />
    <div className={styles.skeletonButlerOption} />
    <div className={styles.skeletonButlerOption} />
    <div className={styles.skeletonButlerOption} />
    <div className={styles.skeletonPopoverOption} />
    <div className={styles.skeletonPopoverOption} />
  </div>
);
